import { Button, Form } from "react-bootstrap";
import Message from "../message";
import { useEffect, useState } from "react";
import axios from "axios";

const Operia = () => {
  const apiServer = `${process.env.REACT_APP_CONFIG_API_SERVER}`;

  const [operia, setOperia] = useState("");
  const [credits, setCredits] = useState(0);
  const [status_operia, setStatus_operia] = useState("");

  const submit_operia = async () => {
    setStatus_operia("");

    if (operia.length <= 0) {
      setStatus_operia("Upload some files!");
    } else {
      const xlsxFormData = new FormData();
      xlsxFormData.set("file", operia);

      const requestOptions = {
        method: "POST",
        body: xlsxFormData,
      };

      let operia_status = "";
      let operia_status_id = "";

      try {
        const operia_response = await fetch(
          apiServer + "api/operia/upload_file",
          requestOptions
        );
        operia_status_id = await operia_response.json();
        operia_status = operia_status_id.detail
          ? operia_status_id.detail
          : operia_status_id;
        setStatus_operia(operia_status);
      } catch (e) {
        console.log(e);
      }
    }
  };

  useEffect(() => {
    (async () => {
      const response = await axios.get(apiServer + "api/operia/credits");

      if (response.status === 200) {
        setCredits(response.data);
      }
    })();
  });

  return (
    <div style={{ marginTop: "20px" }}>
      <p>
        Credits remaining: <strong>{credits}$</strong>
      </p>

      <Form.Control
        id="xlsx"
        name="xlsx"
        type="file"
        onChange={(e) => setOperia(e.target.files[0])}
      />
      <Button
        style={{
          marginTop: "1.25rem",
          marginRight: "1rem",
          backgroundColor: "#3a4c7a",
          border: "none",
        }}
        href="./templates/Operia-Input.xlsx"
        download
      >
        Download Template
      </Button>
      <Button
        variant="primary"
        style={{ marginTop: "20px" }}
        onClick={() => submit_operia()}
      >
        Submit
      </Button>
      {Message(status_operia, setStatus_operia)}
    </div>
  );
};

export default Operia;
